import Swal from "sweetalert2";
import switchNetwork from "./switchNetwork";
// @ts-ignore
const { __, _x, _n, _nx } = wp.i18n;
//@ts-ignore
export default function (dataset, elem: HTMLElement) {
    if(document.getElementById("nft-marketplace-core-confirmation-before-switch") === null) {
        document.body.innerHTML += `
        <template id="nft-marketplace-core-confirmation-before-switch">
          <swal-title>
           ${_x('You need to switch networks to buy this product.', 'nft-marketplace-core')}
          </swal-title>
          <swal-icon type="warning" color="red"></swal-icon>
          <swal-button type="confirm">
           ${_x('Change Network', 'nft-marketplace-core')}
          </swal-button>
          <swal-button type="deny">
           ${_x('Later', 'nft-marketplace-core')}
          </swal-button>
          <swal-param name="allowEscapeKey" value="false" />
          <swal-param
            name="customClass"
            value='{ "popup": "my-popup" }' />
        </template>
    `
    }
    return Swal.fire({
        target: elem.id,
        toast: true,
        template: "#nft-marketplace-core-confirmation-before-switch"
    }).then((result) => {
        if (result.isConfirmed) {
            switchNetwork(dataset, "Localhost 8545")
        }
    })
}